<template>
  <div class="plan-feature-locked" :class="{ 'plan-feature-locked--overlay': overlay }">
    <div class="plan-feature-locked__icon">
      <i class="ph ph-lock-key"></i>
    </div>

    <span class="plan-feature-locked__eyebrow">Recurso do plano</span>
    <h4 class="plan-feature-locked__title">
      {{ title }}
    </h4>
    <p class="plan-feature-locked__message">
      {{ message }}
    </p>

    <button
      type="button"
      class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16"
      @click="goToPayment"
    >
      Trocar plano
      <i class="flaticon-right-arrow ms-5 fs-12"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PlanFeatureLocked",
  props: {
    title: {
      type: String,
      default: "Seu plano atual nao permite usar este modulo",
    },
    message: {
      type: String,
      default: "Esta funcionalidade esta disponivel em planos com atendimento automatico. Troque de plano para liberar o recurso.",
    },
    overlay: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToPayment() {
      this.$router.push("/payment");
    },
  },
});
</script>

<style scoped>
.plan-feature-locked {
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #f2f1f9;
  border-radius: 7px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 320px;
  padding: 34px 24px;
  text-align: center;
  width: 100%;
}

.plan-feature-locked--overlay {
  background-color: rgba(255, 255, 255, 0.92);
  border: 0;
  border-radius: inherit;
  height: 100%;
  inset: 0;
  min-height: auto;
  padding: 26px 24px;
  position: absolute;
  z-index: 5;
}

.plan-feature-locked__icon {
  align-items: center;
  background-color: rgba(108, 99, 255, 0.1);
  border-radius: 50%;
  color: var(--splash-primary-color);
  display: inline-flex;
  font-size: 30px;
  height: 62px;
  justify-content: center;
  margin-bottom: 18px;
  width: 62px;
}

.plan-feature-locked__eyebrow {
  color: var(--splash-primary-color);
  display: block;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.plan-feature-locked__title {
  color: #111827;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: 10px;
}

.plan-feature-locked__message {
  color: #656f7d;
  font-size: 15px;
  line-height: 1.5;
  margin: 0 0 22px;
  max-width: 520px;
}

@media (max-width: 767px) {
  .plan-feature-locked {
    padding: 28px 18px;
  }

  .plan-feature-locked--overlay {
    min-height: auto;
    padding: 22px 18px;
  }

  .plan-feature-locked--overlay .plan-feature-locked__icon {
    font-size: 24px;
    height: 52px;
    margin-bottom: 12px;
    width: 52px;
  }

  .plan-feature-locked__eyebrow {
    font-size: 12px;
    margin-bottom: 8px;
  }

  .plan-feature-locked__title {
    font-size: 20px;
    margin-bottom: 8px;
  }

  .plan-feature-locked__message {
    font-size: 14px;
    margin-bottom: 18px;
  }
}
</style>
